

















import {Component, Prop, Vue} from "vue-property-decorator";
import {FreightServiceStore} from "@/modules/freightservices/store";
import {FreightService} from "@/interfaces/entity/freightservice";

@Component({
    name: "FreightServiceTableAction"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly serviceId!: string;

    get freightService(): FreightService {
        return FreightServiceStore.data[this.serviceId];
    }

    set freightService(value: FreightService) {
        FreightServiceStore.data[this.serviceId] = value;
    }
    async onConfirm() {
        try {
            await FreightServiceStore.deleteFreightService(this.serviceId);
            this.$notification.success({
                message: "Thành công",
                description: "Xóa dịch vụ thành công"
            });
        } catch (e) {
            console.log(e);
            this.$notification.error({
                message: "Thất bại",
                description: "Xóa dịch vụ thất bại"
            });
        }
    }
}
